import axios from 'axios'

// 1. 创建 axios 实例
const service = axios.create({
    // 根据环境变量自动切换接口基准地址
    baseURL: 'https://kooyii-us.wifigsmalarm.com/api',
    timeout: 10000, // 请求超时时间
})

// 2. 请求拦截器 (Request Interceptor)
service.interceptors.request.use(
    (config) => {
        // 每次发送请求之前，如果本地有 token，就在头部携带上
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['token'] = token
        }

        // 如果你接入了多语言配置，也可以在这里统一加上语言头部
        const locale = localStorage.getItem('user-locale')
        if (locale) {
            config.headers['Accept-Language'] = locale
        }

        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

// 3. 响应拦截器 (Response Interceptor)
service.interceptors.response.use(
    (response) => {
        // 假设后端返回的数据格式统一为 { code: 200, message: 'ok', data: {} }
        const res = response.data

        // 如果状态码不是 200，说明业务出错，统一抛出错误提示
        if (res.code !== 0) {
            // 在这里可以通过 UI 库（如 Element Plus / Vant）弹出错误提示
            // ElMessage.error(res.message || 'Error')

            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            // 正常情况下，直接返回核心数据
            return res.data
        }
    },
    (error) => {
        // 处理 HTTP 级别的错误 (如 401未授权, 404找不到, 500服务器错误)
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    console.warn('未登录或登录已过期')
                    // 执行退出登录逻辑，跳转到登录页等
                    break;
                case 500:
                    console.error('服务器内部错误')
                    break;
                default:
                    console.error(`请求错误: ${error.response.status}`)
            }
        }
        return Promise.reject(error)
    }
)

export default service